import DollarOutlined from '@ant-design/icons/DollarOutlined';
import FlagOutlined from '@ant-design/icons/FlagOutlined';
// import TeamOutlined from '@ant-design/icons/TeamOutlined';
// import BookOutlined from '@ant-design/icons/BookOutlined';
import TrophyOutlined from '@ant-design/icons/TrophyOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import {
	buildCompanyMenuUrl,
	COMPANY_MENU_STATUS_LABELS,
} from 'src/utils/data/company-statuses';

const MENU_KEYS = [
	'take',
	'delay',
	'contact',
	'inwork',
	'victory',
	'loss',
	'all',
];

const getSubgroup = ({ prefix = '' } = {}) => {
	return MENU_KEYS.map((menuKey) => ({
		id: `${prefix}_${menuKey}`,
		title: COMPANY_MENU_STATUS_LABELS[menuKey],
		type: 'item',
		url: buildCompanyMenuUrl(prefix, menuKey),
		breadcrumbs: false,
		chip: {
			label: '?',
			size: 'small',
		},
	}));
};

const menuItems = [
	{
		id: 'group-main',
		// title: 'Основные',
		// icon: icons.AppstoreAddOutlined,
		type: 'group',
		children: [
			{
				id: 'commission',
				title: 'Комиссионные',
				type: 'collapse',
				icon: DollarOutlined,
				isDefaultSelected: true,
				breadcrumbs: false,
				children: getSubgroup({ prefix: 'commission' }),
			},
			{
				id: 'subscription',
				title: 'Абонентские',
				type: 'collapse',
				icon: FlagOutlined,
				breadcrumbs: false,
				children: getSubgroup({ prefix: 'abonent' }),
			},
			// {
			// 	id: 'accounts',
			// 	title: 'Аккаунт-менеджмент',
			// 	type: 'collapse',
			// 	icon: TeamOutlined,
			// 	breadcrumbs: false,
			// 	children: getSubgroup({ prefix: 'account-management' }),
			// },
			// {
			// 	id: 'content',
			// 	title: 'Контент-менеджмент',
			// 	type: 'collapse',
			// 	icon: BookOutlined,
			// 	breadcrumbs: false,
			// 	children: getSubgroup({ prefix: 'content-management' }),
			// },
			{
				id: 'worth',
				title: 'Оценка',
				type: 'collapse',
				icon: TrophyOutlined,
				breadcrumbs: false,
				roles: ['admin'],
				children: [
					{
						id: `worth_required`,
						title: 'Требуют оценки',
						type: 'item',
						url: '/worth?filter.required.op=eq&filter.required.value=true',
						breadcrumbs: false,
						chip: {
							label: '?',
							size: 'small',
						},
					},
					{
						id: `worth_rated`,
						title: 'Оцененные',
						type: 'item',
						url: '/worth?filter.required.op=eq&filter.required.value=false',
						breadcrumbs: false,
						chip: {
							label: '?',
							size: 'small',
						},
					},
					{
						id: `worth_all`,
						title: 'Все',
						type: 'item',
						url: '/worth',
						breadcrumbs: false,
						chip: {
							label: '?',
							size: 'small',
						},
					},
				],
			},
			{
				id: 'objection',
				title: 'Возражения',
				type: 'item',
				icon: WarningOutlined,
				url: '/objection',
				breadcrumbs: false,
				chip: {
					label: '?',
					size: 'small',
				},
			},
		],
	},
];

export default menuItems;
